export default __webpack_public_path__ + "static/media/screen5.bd938c1d.png";